import { getccbAxiosConfig } from '../../apisSetup/ccbConfig';
import { EXPENSE_STORE_ADMIN_CONST, EXPENSE_LANDING_CONST } from '../actionConstants';
import { APPLICATION_CONSTANTS, PATHS } from '../../AppConstants';
import { ADMIN_SCREEN_TYPES, defaultSuccessModalData, ADMIN_SCREENS } from '../../expense/pages/ExpenseAdmin/adminConfig';
import { saveServerLogs } from '../../UtilityComponents/Util';
import { setApiSuccess } from './expenseActions';

const GENERIC_ERROR = 'We are facing some technical issue. Please try after sometime';

const ccbAxiosApiCaller = getccbAxiosConfig(true, {
	[APPLICATION_CONSTANTS.DEVICE_TYPE_KEY]: APPLICATION_CONSTANTS.DEVICE_TYPE
}, false);

export const expenseAdminFeatures = (feature, close) => ({
	type: EXPENSE_STORE_ADMIN_CONST.EXPNS_FEATURE_DATA,
	payload: { feature: close ? 0 : feature }
});

export const setAdminScreen = (screen) => ({
	type: EXPENSE_STORE_ADMIN_CONST.ADMIN_SCREEN,
	payload: screen
});

export const setAdminModal = (activeModal, modalData) => ({
	type: EXPENSE_STORE_ADMIN_CONST.ADMIN_MODAL,
	payload: { modalState: { activeModal, modalData } }
});

export const getCatgories = () => async (dispatch) => {
	let errorObj = { screenType: ADMIN_SCREEN_TYPES.CATEGORIES, technicalError: true };
	try {
		dispatch(setApiLoading({ screenType: ADMIN_SCREEN_TYPES.CATEGORIES, pageLevelLoader: true }));
		const response = await ccbAxiosApiCaller.get(PATHS.GET_CATEGORY);
		const responseData = response && response.data;
		if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			errorObj = null;
			dispatch({
				type: EXPENSE_STORE_ADMIN_CONST.ADMIN_CATEGORIES,
				payload: { categoriesList: (responseData && responseData.categories) || [] }
			});
			return;
		}
	} catch (e) {
		saveServerLogs(e.stack, 'error', PATHS.GET_CATEGORY);
	} finally {
		errorObj && dispatch(setApiError(errorObj));
		dispatch(setApiLoading({ screenType: ADMIN_SCREEN_TYPES.CATEGORIES, pageLevelLoader: false }));
	}
};

export const addOrUpdateCategory = (payloadData, modalState) => async (dispatch) => {
	let errorModalObj = { ...modalState,
		['modalData']: { ...modalState.modalData } };
	try {
		dispatch(setApiLoading({ screenType: ADMIN_SCREEN_TYPES.CATEGORIES, modalLevelLoader: true }));
		const response = await ccbAxiosApiCaller.post(PATHS.ADD_OR_UPDATE, payloadData);
		const responseData = response && response.data;
		if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			errorModalObj = null;
			dispatch(screenLevelModals(ADMIN_SCREEN_TYPES.CATEGORIES, { activeModal: '', modalData: {} }));
			dispatch(getCatgories());
			return;
		}
		errorModalObj['modalData']['error'] = { errorMessage: responseData.message };
	} catch (e) {
		errorModalObj['modalData']['error'] = { errorMessage: GENERIC_ERROR };
		saveServerLogs(e.stack, 'error', PATHS.ADD_OR_UPDATE);
	} finally {
		errorModalObj && dispatch(screenLevelModals(ADMIN_SCREEN_TYPES.CATEGORIES, errorModalObj));
		dispatch(setApiLoading({ screenType: ADMIN_SCREEN_TYPES.CATEGORIES, modalLevelLoader: false }));
	}
};

export const deleteCategory = (categoryId) => async (dispatch) => {
	let errorObj = { screenType: ADMIN_SCREEN_TYPES.CATEGORIES, pageLevelError: true, errorMessage: '' };
	try {
		const response = await ccbAxiosApiCaller.delete(`${PATHS.DELETE_CATGORY}${categoryId}`);
		const responseData = response && response.data;
		if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			errorObj = null;
			dispatch(getCatgories());
			return;
		}
		errorObj['errorMessage'] = responseData.message;
	} catch (err) {
		errorObj['errorMessage'] = GENERIC_ERROR;
		saveServerLogs(e.stack, 'error', PATHS.DELETE_CATGORY);
	} finally {
		errorObj && dispatch(setApiError(errorObj));
		dispatch(screenLevelModals(ADMIN_SCREEN_TYPES.CATEGORIES, { activeModal: '', modalData: {} }));
	}
};

export const setApiError = (payloadData) =>({
	type: EXPENSE_LANDING_CONST.EXPENSE_ERROR,
	payload: payloadData
});

export const setApiLoading = (payloadData) =>({
	type: EXPENSE_LANDING_CONST.EXPENSE_LOADING,
	payload: payloadData
});

export const screenLevelModals = (screenType, modalState ) => ({
	type: EXPENSE_STORE_ADMIN_CONST.SCREEN_LEVEL_MODALS,
	payload: { modalState, screenType }
});

export const saveTravelNExpenseForm = (payload) => async (dispatch) => {
	let errorObj = { screenType: ADMIN_SCREEN_TYPES.TRAVEL_N_EXPENSE, errorStatus: true, errorMessage: '' };
	try {
		dispatch(setApiLoading({ screenType: ADMIN_SCREEN_TYPES.TRAVEL_N_EXPENSE, loader: true }));
		const response = await ccbAxiosApiCaller.put(PATHS.TRAVEL_N_EXPENSE_FORM, payload);
		const responseData = response && response.data;
		if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			errorObj = null;
			dispatch(setApiSuccess({ ...defaultSuccessModalData }));
			dispatch(unSavedStateStatus({ screenType: ADMIN_SCREENS.TRAVEL_AND_EXPENSE_SCREEN, status: false }));
			return;
		}
		errorObj['errorMessage'] = responseData.message;
	} catch (err) {
		errorObj['errorMessage'] = GENERIC_ERROR;
		saveServerLogs(e.stack, 'error', PATHS.TRAVEL_N_EXPENSE);
	} finally {
		errorObj && dispatch(setApiError(errorObj));
		dispatch(setApiLoading({ screenType: ADMIN_SCREEN_TYPES.TRAVEL_N_EXPENSE, loader: false }));
	}
};

export const unSavedStateStatus = (payload) => ({
	type: EXPENSE_STORE_ADMIN_CONST.UNSAVED_SCREEN_STATUS,
	payload: payload
});

export const clearpageState = (screen) => (dispatch) => {
	dispatch({
		type: EXPENSE_STORE_ADMIN_CONST.CLEAR_STATE,
		payload: { screenType: screen }
	});
};

export const getTravelNExpenseData = () => async (dispatch) => {
	let errorObj = { screenType: ADMIN_SCREEN_TYPES.TRAVEL_N_EXPENSE, errorStatus: true, errorMessage: '' };
	try {
		dispatch(setApiLoading({ screenType: ADMIN_SCREEN_TYPES.TRAVEL_N_EXPENSE, loader: true }));
		const response = await ccbAxiosApiCaller.get(PATHS.GET_TNE_DATA);
		const responseData = response && response.data;
		if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			errorObj = null;
			dispatch({
				type: EXPENSE_STORE_ADMIN_CONST.T_N_E_DATA,
				payload: { data: responseData }
			});
			return;
		}
		errorObj['errorMessage'] = responseData.message;
	} catch (e) {
		errorObj['errorMessage'] = GENERIC_ERROR;
		saveServerLogs(e.stack, 'error', PATHS.GET_TNE_DATA);
	} finally {
		errorObj && dispatch(setApiError(errorObj));
		dispatch(setApiLoading({ screenType: ADMIN_SCREEN_TYPES.TRAVEL_N_EXPENSE, loader: false }));
	}
};
